<template>
  <div>
    <van-tabbar v-model="active" route>
      <van-tabbar-item
        v-for="(tab, index) in tabbar"
        :icon="tab.icon"
        replace
        placeholder
        :to="tab.path"
        :dot="tab.dot"
        :badge="tab.badge"
        :key="index">
        {{ $t(`tabbar.${tab.name}`) }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'tabbar',
  data() {
    return {
      active: 0,
      tabbar: [
        {
          name: 'home',
          path: '/',
          pathName: 'home',
          icon: 'home-o',
          dot: false,
          badge: ''
        },
        {
          name: 'trading',
          path: '/trading',
          pathName: 'trading',
          icon: 'pending-payment',
          dot: false,
          badge: ''
        },
        {
          name: 'invest',
          path: '/invest',
          pathName: 'invest',
          icon: 'chart-trending-o',
          dot: false,
          badge: ''
        },
        {
          name: 'share',
          path: '/share',
          pathName: 'share',
          icon: 'guide-o',
          dot: false,
          badge: ''
        },
        {
          name: 'mine',
          path: '/mine',
          pathName: 'mine',
          icon: 'contact',
          dot: false,
          badge: ''
        }
      ]
    }
  },
  watch: {
    $route: 'changeActive'
  },
  created() {
    const toName = this.$route.name;
    this.setActive(toName);
  },
  methods: {
    changeActive({ name }) {
      this.setActive(name);
    },
    setActive(name) {
      this.tabbar.forEach((tab, i) => {
        if (tab.pathName == name) {
          this.active = i;
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
</style>
